import PortalIdParser from 'PortalIdParser';
import { ObjectTypeIdRegexStrict, StandardObjectTypeIdRegex } from '../filterQueryFormat/ObjectTypeId';
import InboundDbListMembershipProperty from '../converters/crmSearch/psuedoProperties/InboundDbListMembershipProperty';
import * as ObjectTypeIds from 'customer-data-objects/constants/ObjectTypeIds';
const orderedParamKeys = ['action', 'type', 'property'];

// https://product.hubteam.com/docs/crm-properties-fe-handbook/properties/PropertySettingsUI/deepLinks.html#deep-links
const buildDeepLink = params => {
  const queryParams = new URLSearchParams(orderedParamKeys.flatMap(key => {
    const value = params[key];
    return typeof value === 'undefined' ? [] : [[key, value]];
  }));
  return `/property-settings/${PortalIdParser.get()}/properties?${queryParams}`;
};

// These object types appear for users in property settings unconditionally
// Some other object types may have conditions defined in this framework app setting:
//    https://tools.hubteam.com/lighthouse/framework-app-settings/crmPropertySettingsUI/definition
// Some other objects must be activated by users in the object library:
//    https://tools.hubteam.com/api-catalog/services/ObjectLibraryService/v1/spec/internal#operations-Object_Library-get-%2Fobject-library%2Fv1
const linkableStandardObjectTypes = new Set([ObjectTypeIds.CONTACT_TYPE_ID, ObjectTypeIds.COMPANY_TYPE_ID, ObjectTypeIds.DEAL_TYPE_ID]);

// These properties on standard objects are virtual
//   and will not appear in property settings
const unlinkableStandardObjectProperties = new Set(['associatedcompanyid', 'associations.company', 'associations.contact', 'formSubmissions.formId', '_inbounddbio.importid_', 'listMemberships.listId', InboundDbListMembershipProperty.name]);
export const getPropertySettingsLink = (objectTypeId, propertyName, action) => {
  if (!ObjectTypeIdRegexStrict.test(objectTypeId)) {
    // The property does not belong to a standard, app, or custom object
    //   eg: the property belongs to an event or HubDB object
    return null;
  }
  if (StandardObjectTypeIdRegex.test(objectTypeId) && (!linkableStandardObjectTypes.has(objectTypeId) || unlinkableStandardObjectProperties.has(propertyName))) {
    // The property belongs to a standard object
    //    but the standard object is not linkable
    //    or the property is not linkable
    return null;
  }
  return buildDeepLink({
    type: objectTypeId,
    property: propertyName,
    action
  });
};